var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { UPDATE_KYC_STATE_REQUEST, updateKYCstateFailure, updateKYCstateSuccess } from "@/redux/actions";
import APIIN from "@/utils/APIIN";
import { call, put, takeLatest } from "redux-saga/effects";
export const onUpdateKYCstate = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            APIIN.put(`/company/admin/kyc/status`, action.payload)
                .then((data) => {
                resolve(data);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* fetchUpdateKYCstateWorker(action) {
    try {
        const data = yield call(onUpdateKYCstate, action);
        yield put(updateKYCstateSuccess(data));
    }
    catch (error) {
        yield put(updateKYCstateFailure(error));
    }
}
export function* watchFetchUpdateKYCstateData() {
    yield takeLatest(UPDATE_KYC_STATE_REQUEST, fetchUpdateKYCstateWorker);
}
